export default __webpack_public_path__ + "static/media/watermelon.e0601d64.jpg";